// src/components/HashLink.js
import { useNavigate, useLocation } from "react-router-dom";

// Renders an anchor that navigates to `to` (e.g. "/#services") and,
// after landing on the target route, smoothly scrolls to the #section.
export default function HashLink({ to, className, children, onClick, ...rest }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [path, hash] = to.split("#"); // "/#services" -> ["/", "services"]
  const targetPath = path || "/";

  const scrollToHash = (id) => {
    // wait a tick so the target page has rendered
    requestAnimationFrame(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) onClick(e);

    if (!hash) {
      navigate(targetPath);
      return;
    }

    if (location.pathname === targetPath) {
      // already on the page — just scroll
      scrollToHash(hash);
    } else {
      // go to the page first, then scroll once it mounts
      navigate(targetPath, { state: { scrollTo: hash } });
    }
  };

  return (
    <a href={to} onClick={handleClick} className={className} {...rest}>
      {children}
    </a>
  );
}